/**
 * クッキーのキーを表します。
 */
export class N201SessionStorageKey {
  // 検索条件
  public static readonly N2011SearchData: string = 'N2011SearchData';
  // 検索ボタン押下時の検索条件
  public static readonly N2011SessionSearchData: string = 'N2011SessionSearchData';
  // お届け先リスト
  public static readonly N2011OtodokesakiList: string = 'N2011OtodokesakiList';
  // 関連部材
  public static readonly N2013HatchuData: string = 'N2013HatchuData';
  public static readonly N202HatchuData: string = 'N202HatchuData';
  // 表示区分
  public static readonly N2021InitialKbn: string = 'N2021InitialKbn';
  // 遷移フラグ
  public static readonly N202SeniFlg: string = 'N202SeniFlg';
  // 商品区分
  public static readonly N202ShohinKubun: string = 'N202ShohinKubun';
  // 発注予定リスト
  public static readonly N202HatchuYoteiList: string = 'N202HatchuYoteiList';

  public static readonly N2013Otodokesakukubun: string = 'Otodokesakukubun';
  public static readonly N2013Okurisaki: string = 'N2013Okurisaki';
  public static readonly N2013Yubimbango: string = 'N2013Yubimbango';
  public static readonly N2013Todofuken: string = 'N2013Todofuken';
  public static readonly N2013Jusho: string = 'N2013Jusho';
  public static readonly N2013Shohinkubun: string = 'N2013Shohinkubun';

  // N2012画面、戻るボタン、遷移フラグ
  public static readonly N201GAMENSENI: string = "N201GAMENSENI";
  // ST-190 Start
  public static readonly N201GurupukubunKengenFlg: string = "N201GurupukubunKengenFlg";
  // ST-190 End

}



// WEBPACK FOOTER //
// ./src/app/modules/n201/n201-session-storage-key.ts